<template>
	<div id="generator" class="w-header__button w-generator">
		<div class="w-generator__modal" :class="{ 'w-is-visible': !isCurrentStep(0) }">
			<button class="w-generator__close" @click="exitGenerator()" aria-label="Schließen"><svgicon aria-hidden="true" icon="close" /></button>
			<div class="w-generator__section w-generator__section--start" :class="{ 'w-is-active': isCurrentStep(1) }">
				<div class="w-generator__section-inner">

					<p class="w-o-format-medium w-o-space-t-md">Fehlen Ihnen die Worte?</p>
					<p class="w-o-format-lead w-o-space-t-md">Erstellen Sie hier mit wenigen Klicks Ihre emotionale Markenstory.</p>
					<p class="w-o-format-text w-o-space-t-lg">Gratis. Und ganz im Sinne des <a href="datenschutz.html#werbetextgenerator" class="w-o-format-anchor">Datenschutzes</a>.</p>
					<p class="w-o-format-lead w-o-space-t-lg">
						<button class="w-o-format-link" @click="runQuestions()">Los geht’s!</button>
					</p>

				</div>
			</div>
			<ol class="w-generator__section w-generator__section--questions" :class="{ 'w-is-active': isCurrentStep(2) }">
				<li v-for="(question, number) in questions" class="w-generator__question" :class="['w-generator__question--'+(number+1), { 'w-is-current': isCurrentQuestion(number) }]" :id="question.id" :key="question.id">
					<div class="w-generator__question-inner">
						<div class="w-o-format-lead">{{ number+1 }}</div>
						<div class="w-o-format-tiny w-o-space-t-md">{{ question.label }}</div>
						<div class="w-generator__answer  w-generator__answer--text w-o-space-t-md" v-if="question.type === 'input'">
							<input class="w-o-format-input" type="text" :placeholder="question.placeholder" v-model.trim="question.value" @keyup="onKeyUp($event, question, number)" :ref="number" />
							<div class="w-generator__answer-controls w-o-space-t-xl">
								<div class="w-o-format-text">
									<button class="w-o-format-link" @click="answerQuestion(number, true)" :disabled="question.value.length >= 3">Überrasche mich…</button>
									<button class="w-o-format-link" @click="answerQuestion(number)" :disabled="question.value.length < 3">Weiter</button>
								</div>
							</div>
						</div>
						<div class="w-generator__answer w-generator__answer--multi" v-else-if="question.type === 'multi_check'">
							<ul class="w-o-space-t-lg">
								<li v-for="(choice, index) in question.choices" :key="index+1"><input type="checkbox" :id="index+1" :name="question.id" :value="choice.value" v-model="question.values" /><label class="w-o-format-lead" :for="index+1"><span>{{ choice.label }}</span></label></li>
							</ul>
							<div class="w-generator__answer-controls w-o-space-t-xl">
								<div class="w-o-format-text">
									<button class="w-o-format-link" @click="answerQuestion(number)" :disabled="question.values.length !== 3">Weiter</button>
								</div>
							</div>
						</div>
					</div>
				</li>
			</ol>
			<div class="w-generator__section w-generator__section--loading" :class="{ 'w-is-active': isCurrentStep(3) }">
				<span class="w-o-format-lead">Ihr Werbetext wird erstellt…</span>
			</div>
			<div class="w-generator__section w-generator__section--end" :class="{ 'w-is-active': isCurrentStep(4) }">
				<div>
					<p class="w-o-format-text">{{ this.questions[1].value }} hatte eine Vision. Wollte etwas schaffen, {{ this.questions[3].values[0] }} und {{ this.questions[3].values[1] }} als alles bisher Dagewesene. Wollte Gutes tun. Das Leben für {{ this.questions[2].value }} verbessern. Und vor allem erleichtern. Die Vision wurde Realität. {{ this.questions[0].value }} war geboren. Und die Welt wurde damit um ein großes Stück {{ this.questions[3].values[2] }}.</p>
					<p class="w-o-format-medium w-o-space-t-md">{{ this.questions[0].value }}</p>
					<p class="w-o-format-lead w-o-space-t-sm">{{ this.questions[4].value }}</p>
					<p class="w-o-format-text w-o-space-t-xl">Fertig.</p>
					<p class="w-o-format-text w-o-space-t-md">Aber vermutlich sind wir noch nicht dort, wo wir hin wollen.</p>
					<div class="w-o-space-t-md">
						<button class="w-specialbutton w-specialbutton--inverted" @click="exitGenerator()"><span class="w-specialbutton__inner w-o-format-text">Geht da mehr?</span></button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import '@/assets/compiled-icons/close';

export default {
	name: 'Generator',
	block: 'generator',
	data() {
		return {
			activeStep: 0,
			activeQuestion: 0,
			surprise: 0,
			questions: [
				{
					id: 'name',
					label: 'Wie heißt Ihre Marke?',
					placeholder: 'Markenname',
					type: 'input',
					value: '',
					surprises: [
						'Ich AG',
						'Die schnelle Mark',
						'YawnUp',
					],
				},
				{
					id: 'person',
					label: 'Welche Person steht hinter Ihrer Marke?',
					placeholder: 'Person',
					type: 'input',
					value: '',
					surprises: [
						'Lux Lustermann',
						'Phoebe Buffet',
						'Mr. Walnutbutter',
					],
				},
				{
					id: 'audience',
					label: 'Geben Sie hier die Zielgruppe Ihrer Marke ein.',
					placeholder: 'Zielgruppe',
					type: 'input',
					value: '',
					surprises: [
						'ehemalige Olympia-Teilnehmerinnen',
						'die Zielgruppe 95+',
						'hungrige Schaffner',
					],
				},
				{
					id: 'attributes',
					label: 'Wählen Sie drei Attribute, die die Marke auszeichnen.',
					placeholder: 'Attribute',
					type: 'multi_check',
					choices: [
						{
							label: 'pikant',
							value: 'pikanter',
						},
						{
							label: 'süß',
							value: 'süßer',
						},
						{
							label: 'praktisch',
							value: 'praktischer',
						},
						{
							label: 'zeitgemäß',
							value: 'zeitgemäßer',
						},
						{
							label: 'aufregend',
							value: 'aufregender',
						},
						{
							label: 'strahlend',
							value: 'strahlender',
						},
						{
							label: 'digital',
							value: 'digitaler',
						},
						{
							label: 'ästhetisch',
							value: 'ästhetischer',
						},
					],
					values: [],
				},
				{
					id: 'summary',
					label: 'Fassen Sie den Kern Ihrer Marke in einem Satz zusammen.',
					placeholder: 'Zusammenfassung',
					type: 'input',
					value: '',
					surprises: [
						'Ein Produkt, das niemand jemals weggeworfen wird',
						'Eine olfaktorische Wohltat',
						'Besser geht’s eigentlich fast nicht wirklich',
					],
				},
			],
		}
	},
	methods: {
		startGenerator: function() {
			document.body.classList.add('w-has-generator-transition');
			document.body.classList.add('w-has-generator-visible');

			this.surprise = Math.floor(Math.random() * this.questions[0].surprises.length); // select surprise level
			this.activeQuestion = 0; // go to question 1
			this.activeStep = 1; // go to section 2

		},
		runQuestions: function() {
			// reset content
			for (let i=0; i<this.questions.length; i++) {
				if (this.questions[i].value) {
					this.questions[i].value = '';
				}
				else if (this.questions[i].values) {
					this.questions[i].values = [];
				}
			}

			this.activeStep = 2;
		},
		exitGenerator: function() {
			document.body.classList.remove('w-has-generator-visible');

			setTimeout(function() {
				document.body.classList.remove('w-has-generator-transition');
				
				document.querySelector('#about').scrollIntoView({ behavior: 'smooth' });
			}, 1000);

			this.activeStep = 0; // go to section 1
		},
		answerQuestion: function(index, surprise = false) {
			if (surprise) {
				this.questions[index].value = this.questions[index].surprises[this.surprise];
			}

			this.activeQuestion++;

			if (this.activeQuestion === this.questions.length) {
				this.activeStep = 3;

				setTimeout(function() {
					this.activeStep = 4;
				}.bind(this), 2500);
			}
			else {
				if (this.$refs[this.activeQuestion]) {
					setTimeout(function() {
						this.$refs[this.activeQuestion][0].focus();
					}.bind(this), 1000);
				}
			}
		},
		isCurrentStep: function(int) {
			return int === this.activeStep;
		},
		isCurrentQuestion: function(int) {
			return int === this.activeQuestion;
		},
		onKeyUp: function(event, question, number) {
			if (event.which === 13) { // enter
				if (question.value.length >= 3) {
					this.answerQuestion(number);
				}
			}
		},
	},
	mounted() {
		const button = document.querySelector('[data-w-trigger-generator]');
		button.addEventListener('click', () => {
			this.startGenerator();
		});
	},
};
</script>

<style lang="scss">

@import "@/assets/styles/_base.scss";
@import "@/assets/styles/style.scss";

.w-generator {
	cursor: default;
}
.w-generator__button {
	cursor: pointer;

	span {
		display: block;
	}
	span + span {
		margin-top: 0.25em;
	}
}
.w-generator__modal {
	position: fixed;
	z-index: 11;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	// background-color: w-get-color("white");
	color: w-get-color("black");

	will-change: opacity, visibility, transform;
	visibility: hidden;
	opacity: 0;
	transform: translateX(100%);

	transition:
		opacity $w-transition*3 w-get-easing("fast"),
		visibility $w-transition*3 w-get-easing("fast"),
		transform $w-transition*3 w-get-easing("fast");

	&.w-is-visible {
		visibility: visible;
		opacity: 1;
		transform: translateX(0);
	}
}
.w-generator__close {
	cursor: pointer;
	position: absolute;
	z-index: 10;
	top: 1em;
	left: 50%;
	margin-left: -2em;
	padding: 1em;
	border-radius: 100%;
	// background-color: w-get-color("white");

	transition: transform $w-transition*0.25 w-get-easing("smooth");

	outline: none;

	&:hover {
		transform: scale(1.05);
	}
	&:active {
		transform: scale(0.9);
	}

	svg {
		width: 2em;
		height: 2em;
	}
}
.w-generator__section {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1;

	will-change: opacity, visibility, transform;
	visibility: hidden;
	opacity: 0;
	transform: scale(0.95);

	transition:
		opacity $w-transition*3 w-get-easing("smooth"),
		visibility $w-transition*3 w-get-easing("smooth"),
		transform $w-transition*3 w-get-easing("smooth");

	&.w-is-active {
		z-index: 2;
		visibility: visible;
		opacity: 1;
		transform: scale(1.0);
		transition-delay: 0s;
	}
}
.w-generator__section--start {
	.w-generator__section-inner {
		max-width: $w-small-width;
		margin: 0 auto;
	}
}
.w-generator__section--start,
.w-generator__section--loading {
	display: flex;
	align-items: center;
	text-align: center;
}
.w-generator__section--loading {
	&.w-is-active {
		transition-duration: $w-transition*8;
	}
}
.w-generator__section--end {
	padding-top: 6em;
	padding-bottom: $w-gutter*2;
	overflow-x: hidden;
	overflow-y: auto;

	& > div {
		margin: 0 auto;
		text-align: center;
		padding: $w-gutter;
		max-width: $w-opt-width;
	}

	button + button {
		margin-left: 1em;
	}
}

.w-generator__question {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	will-change: opacity, visibility, transform;
	visibility: hidden;
	opacity: 0;
	transform: scale(0.95);

	transition:
		opacity $w-transition*3 w-get-easing("fast"),
		visibility $w-transition*3 w-get-easing("fast"),
		transform $w-transition*3 w-get-easing("fast");

	&.w-is-current {
		visibility: visible;
		opacity: 1;
		transform: scale(1.0);
		transition-delay: $w-transition*1.5;
	}
}
.w-generator__question-inner {
	text-align: center;
	flex: 0;
	padding-bottom: 2em;
}
.w-generator__answer {

	input {
		border: none;
		text-align: center;
		background: transparent;
		line-height: 1.75;

		&::placeholder {
			color: currentColor;
			opacity: 0.125;
		}

		background-image: linear-gradient(90deg, currentColor, currentColor);
		background-position: bottom center;
		background-size: 0 2px;
		background-repeat: no-repeat;
		transition: background-size $w-transition w-get-easing("smooth");

		&:focus {
			outline: none;
			background-size: 100% 2px;
		}

		&[type="checkbox"] {
			position: absolute;
			opacity: 0;

			& + label {
				cursor: pointer;
				@extend %w-o-format-link;
			}
		}
	}

	button {
		display: block;
		margin: $w-gutter auto;
	}
}
.w-generator__answer--text {
	button {
		&:disabled {
			display: none;
		}
	}
}
.w-generator__answer--multi {
	max-width: $w-small-width;

	li {
		display: inline-block;
	}
	li + li {
		margin-left: 2em;
	}

	button {
		&:disabled {
			opacity: 0.25;
		}
	}
}

.w-generator__answer-controls {
	display: block;
	// * {
	// 	// padding: 1em;
	// }
}

</style>
